import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle} from '../Common/style'

class PutAway extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPutAway();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once scrapRecords is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.putAway;
        if (nextProps.putAway && nextProps.putAway != this.props.putAway) {
            this.setState({
                rows: nextProps.putAway
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page

    setCurrentPutAway(e) {
        e.preventDefault();
        const currentPutAway = this.state.selectedRows[0];
        this.props.selectPutAway(currentPutAway);
        this.context.router.push('/putAway/'+currentPutAway.WarehousePutAway_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPutAway();
        this.context.router.push('/putAway/new');
    }

    clickInbound(e) {
        e.preventDefault();
        this.props.resetCurrentPutAway();
        this.context.router.push('/putAway/inbound');
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const columns = [
              {
                  key: 'PutAwayNum',
                  name: <Translate value="put_away_num" />,
                  resizable: true,
                  width: 130,
                  sortable: true,
                  filterable: true,
                  locked: true
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="create_time" />,
                  resizable: true,
                  width: 110,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'Modify_Username',
                  name: <Translate value="user" />,
                  resizable: true,
                  width: 80,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Note',
                  name: <Translate value="note" />,
                  resizable: true,
                  width: 190,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'IsPutAway',
                  name: <Translate value="completed" />,
                  resizable: true,
                  width: 100,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PutAway-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehousePutAway_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={685}
                        onRowUpdated={handleRowUpdated}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        return (
          //---------------
          // Begin HTML: Create New/Edit Put Away
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="put_away_list" />
                </Breadcrumb.Item>
              </Breadcrumb>
                {/* <div className="content-heading"><Translate value="put_away_list" /></div> */}
                <Grid id="put-away-list">
                  <Panel className="position-relative table-collapse-fix">
                    <ButtonToolbar>
                          <Button bsStyle="primary"  onClick={(e) => this.clickNew(e) } disabled={this.checkPermission("add_put_away")}>
                              <em className="fa fa-plus marginRightStyle" /><Translate value="create_put_away" />
                          </Button>
                          <Button bsStyle="primary"  onClick={(e) => this.setCurrentPutAway(e) } disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                              <em className="fa fa-plus marginRightStyle" /><Translate value="edit_put_away" />
                          </Button>
                          <Button bsStyle="primary"  onClick={(e) => this.clickInbound(e) } disabled={this.checkPermission("add_put_away")}>
                              <em className="fa fa-plus marginRightStyle" /><Translate value="inbound" />
                          </Button>
                          <Button bsStyle="primary" >
                              <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                          </Button>
                          <Button bsStyle="primary" >
                              <em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                          </Button>
                    </ButtonToolbar>
                    {this.renderTable() }
                  </Panel>
                </Grid>
            </ContentWrapper>
        );
    }
}



export default PutAway;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/putAway.jsx